import { render, staticRenderFns } from "./EbookImageCard.vue?vue&type=template&id=f50fc2ac&scoped=true&"
import script from "./EbookImageCard.vue?vue&type=script&lang=js&"
export * from "./EbookImageCard.vue?vue&type=script&lang=js&"
import style0 from "./EbookImageCard.vue?vue&type=style&index=0&id=f50fc2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50fc2ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
